import {useEffect} from 'react';

import {useDialogCrup} from '../../../../../shared/hooks/DialogCrup';
import {getDecreeText} from '../../../../../shared/utils/invoice';

import {DeclareRegisterInvoiceService as Service} from '../../DeclareRegisterInvoiceService';

import {TokenElement} from './token-element';
import {useTranslation} from '../../../../../shared/language';

export const Crup = ({header, dataKey, tokens, setTokens, reloadTokens, refreshLazyData}) => {
  const {t} = useTranslation();

  const formatData = (data) => {
    if (data.formInvoice) {
      data.formInvoice = data.formInvoice.join(',');
    }
    if (data.formSendData) {
      data.formSendData = data.formSendData.join(',');
    }
    if (data.invoiceTypeUse) {
      data.invoiceTypeUse = data.invoiceTypeUse.join(',');
    }
    if (data.method) {
      data.method = data.method.join(',');
    }
    data.token = tokens;
    return data;
  }

  const {render, create, update, getValue, setValue, touched} = useDialogCrup({
    header,
    dataKey,
    width: '80rem',
    fields: [
      {field: 'cityCode', type: 'hidden'},
      {field: 'cityName', type: 'hidden'},
      {field: 'taxAuthorityCode', type: 'hidden'},
      {type: 'custom', className: 'md:col-12 text-center mb-0', body: <h2 className="mb-0">{t('common.declarationFormTitle')}</h2>},
      {type: 'custom', className: 'md:col-12 text-center', body: <h5>{t('common.declarationFormSubtitle')}</h5>},
      {
        field: 'formality', type: 'RadioButton', wrapName: 'justify-content-center', RadioButtonProps: {
          RadioButtons: [
            {className: 'md:col-2', value: 1, label: t('common.declarationRegisterNew')},
            {className: 'md:col-2', value: 2, label: t('common.declarationChangeInfo')}
          ]
        }
      },
      {field: 'dateCreate', header: t('common.declarationDate'), required: true, type: 'Calendar', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'region', header: t('common.placeOfCreation'), required: true, InputTextProps: {maxLength: 400}, className: 'md:col-6', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8'},
      {field: 'taxpayers', header: t('common.taxpayerName'), type: 'text', className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10'},
      {field: 'taxCode', header: t('common.taxCode'), type: 'tax-code', className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10'},
      {field: 'taxAuthorityName', header: t('common.managedTaxAuthority'), type: 'text', className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10'},
      {
        type: 'custom', className: 'md:col-12 text-center', body: (
          <div className="p-message p-component p-message-warn p-message-enter-done">
            <div className="p-message-wrapper">
              <span className="p-message-icon pi pi-info-circle"></span>
              <span className="p-message-detail">{t('common.acceptedDeclarationNotice')}</span>
            </div>
          </div>
        )
      },
      {field: 'personContact', header: t('common.contactPerson'), required: true, InputTextProps: {maxLength: 50}, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10'},
      {field: 'address', header: t('common.contactAddress'), required: true, InputTextProps: {maxLength: 400}, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10'},
      {field: 'email', header: t('common.contactEmail'), required: true, InputTextProps: {maxLength: 50}, className: 'md:col-8', labelClassName: 'md:col-3', inputClassName: 'md:col-9'},
      {field: 'phone', header: t('common.contactPhone'), required: true, InputTextProps: {maxLength: 20}, className: 'md:col-8', labelClassName: 'md:col-3', inputClassName: 'md:col-9'},
      {
        type: 'template',
        className: 'md:col-12',
        template: (item) => <p>{getDecreeText(item?.dateCreate)}</p>
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>{t('common.invoiceFormSection')}</b>
      },
      {
        field: 'formInvoice', type: 'MultiCheckbox', className: 'pl-4', MultiCheckboxProps: {
          Checkboxes: [
            {value: 'CMa', translationKey: 'common.invoiceWithTaxCode'},
            {value: 'CMTMTTien', translationKey: 'common.invoiceWithCashRegister'},
            {value: 'KMa', translationKey: 'common.invoiceWithoutTaxCode'}
          ]
        }
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>{t('common.invoiceDataSendingSection')}</b>
      },
      {
        type: 'custom', className: 'md:col-12 text-center pl-4', body: (
          <div className="p-message p-component p-message-warn p-message-enter-done">
            <div className="p-message-wrapper">
              <span className="p-message-icon pi pi-info-circle"></span>
              <span className="p-message-detail">{t('common.skipIfNotApplicable')}</span>
            </div>
          </div>
        )
      },
      {
        type: 'custom', className: 'md:col-12', body: <span className="pl-5">{t('common.codedInvoiceWithoutServiceFeeCase')}</span>
      },
      {
        field: 'formSendData', type: 'MultiCheckbox', className: 'pl-8', MultiCheckboxProps: {
          Checkboxes: [
            {
              value: 'DBKK', translationKey: 'common.difficultAreaBusiness', disabledDependency: (item) => {
                return item.formInvoice && item.formInvoice.includes('KMa');
              }
            },
            {
              value: 'UBND',
              translationKey: 'common.otherSmallBusiness',
              disabledDependency: (item) => {
                return item.formInvoice && item.formInvoice.includes('KMa');
              }
            }
          ]
        }
      },
      {
        type: 'custom', className: 'md:col-12', body: <span className="pl-5">{t('common.noCodeInvoiceCase')}</span>
      },
      {
        field: 'formSendData', type: 'MultiCheckbox', className: 'pl-8', MultiCheckboxProps: {
          Checkboxes: [
            {
              value: 'GTT', translationKey: 'common.directToTaxAuthority', disabledDependency: (item) => {
                return item.formInvoice && (item.formInvoice.includes('CMa') || item.formInvoice.includes('KMa'));
              }
            },
            {
              value: 'TVAN', translationKey: 'common.viaInvoiceProvider', disabledDependency: (item) => {
                return item.formInvoice && (item.formInvoice.includes('CMa') || item.formInvoice.includes('KMa'));
              }
            }
          ]
        }
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>{t('common.dataTransferMethodSection')}</b>
      },
      {
        field: 'method', type: 'MultiCheckbox', className: 'pl-4', MultiCheckboxProps: {
          Checkboxes: [
            {
              value: 'CDDu', translationKey: 'common.fullInvoiceContent', disabledDependency: (item) => {
                return item.formInvoice && (item.formInvoice.includes('CMa') || item.formInvoice.includes('CMTMTTien'));
              }
            },
            {
              value: 'CBTH', translationKey: 'common.summaryInvoiceData', disabledDependency: (item) => {
                return item.formInvoice && !item.formInvoice.includes('KMa');
              }
            }
          ]
        }
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>{t('common.invoiceTypeUseSection')}</b>
      },
      {
        field: 'invoiceTypeUse', type: 'MultiCheckbox', className: 'pl-4', MultiCheckboxProps: {
          Checkboxes: [
            {value: 'GTGT', label: t('common.vatInvoice')},
            {value: 'HDBH', label: t('common.salesInvoice')},
            {value: 'BTSC', label: t('common.publicAssetInvoice')},
            {value: 'DTQG', label: t('common.nationalReserveInvoice')},
            {value: 'HDK', label: t('common.legacyOtherInvoiceTypes')},
            {value: 'CTu', label: t('common.legacyManagedDocumentsAsInvoice')}
          ]
        }
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>{t('common.certificateUseSection')}</b>
      },
      {
        type: 'custom', className: 'md:col-12', body: <TokenElement tokens={tokens} setTokens={setTokens} reloadTokens={reloadTokens}/>
      }
    ],
    createItem: (item) => {
      return Service.create(formatData(item));
    },
    updateItem: (id, item) => {
      return Service.update(id, formatData(item));
    },
    refreshLazyData,
    layout: 'Horizontal',
    formClassName: 'paper'
  });

  const {formInvoice} = getValue();

  useEffect(() => {
    if (formInvoice && touched) {
      if (formInvoice.length >= 1 && formInvoice.includes('KMa')) {
        const value = {...getValue()};
        value.formSendData = ['TVAN'];
        value.method = ['CDDu'];
        if (value.dateCreate) {
          value.dateCreate = new Date(value.dateCreate);
        }
        setValue(value);
      } else if (formInvoice.includes('CMa') || formInvoice.includes('CMTMTTien')) {
        const value = {...getValue()};
        value.formSendData = [];
        value.method = ['CDDu'];
        if (value.dateCreate) {
          value.dateCreate = new Date(value.dateCreate);
        }
        setValue(value);
      } else if (formInvoice.includes('KMa')) {
        const value = {...getValue()};
        value.formSendData = ['TVAN'];
        value.method = [];
        if (value.dateCreate) {
          value.dateCreate = new Date(value.dateCreate);
        }
        setValue(value);
      }
    }
  }, [formInvoice]); // eslint-disable-line react-hooks/exhaustive-deps

  return {render, create, update, setValue};
}
